import React, { useState, useEffect, useRef } from "react";
import {
  FaClipboardList,
  FaChevronDown,
  FaChevronUp,
  FaUserTie,
  FaTags,
  FaMoneyBillWave,
  FaChartBar,
  FaCog,
  FaHotel,
  FaHome,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { GiWorld } from "react-icons/gi";
import logo from "../../assets/logo-white.png";
import smalllogo from "../../assets/yellow-logo.png";
import { IoCarSport } from "react-icons/io5";
import { RxActivityLog } from "react-icons/rx";
import { FaPeopleGroup } from "react-icons/fa6";
import { MdLeaderboard } from "react-icons/md";
import { SiExpensify } from "react-icons/si";

export default function HotelSideNav({ open, toggle }) {
  const [openPackages, setOpenPackages] = useState(false);
  const [openHotel, setOpenHotel] = useState(false);

  const startX = useRef(0);

  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const endX = e.changedTouches[0].clientX;
    if (startX.current - endX > 80) toggle();
  };

  useEffect(() => {
    if (!open) {
      setOpenPackages(false);
      setOpenHotel(false);
    }
  }, [open]);

  return (
    <div
      className={`sidenav ${open ? "open" : "collapsed"}`}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div className="sidenav-header">
        <div className="d-flex justify-content-center align-items-center">
          <img
            src={open ? logo : smalllogo}
            alt="App Logo"
            className="img-fluid"
            style={{
              maxWidth: open ? "140px" : "35px",
              transition: "all 0.3s ease",
            }}
          />
        </div>
      </div>

      <div className="sidenav-menu">
        <ul className="menu">
          <li>
            <NavLink
              to="/hotel/home"
              end
              data-label="Home"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaHome size={20} /> <span className="text">Dashboard</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/hotel/vendor"
              data-label="vendor"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaPeopleGroup size={20} />
              <span className="text">Service Providers</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/hotel/places"
              data-label="Places"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <GiWorld size={20} /> <span className="text">Places</span>
            </NavLink>
          </li>

          <li>
            <div
              className="menu-parent"
              onClick={() => open && setOpenHotel(!openHotel)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
                padding: "12px 20px",
                cursor: "pointer",
                color: "#f5c430",
              }}
            >
              <FaHotel size={20} onClick={toggle} />
              <span className="text">Hotels</span>
              {open && (
                <span style={{ marginLeft: "auto" }}>
                  {openHotel ? (
                    <FaChevronUp size={14} />
                  ) : (
                    <FaChevronDown size={14} />
                  )}
                </span>
              )}
            </div>

            {open && openHotel && (
              <ul
                className="submenu"
                style={{
                  listStyle: "none",
                  paddingLeft: "55px",
                  paddingTop: "6px",
                }}
              >
                <li>
                  <NavLink
                    to="/hotel/hotellist"
                    style={{
                      color: "#f5c430",
                      fontSize: "13px",
                      padding: "8px 0",
                      display: "block",
                      paddingLeft: "10px",
                    }}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Hotels
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    style={{
                      color: "#f5c430",
                      fontSize: "13px",
                      padding: "8px 0",
                      display: "block",
                      paddingLeft: "10px",
                    }}
                    to="/hotel/roomtype"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Rooms
                  </NavLink>
                </li>
              </ul>
            )}
          </li>

          <li>
            <NavLink
              to="/hotel/lead"
              data-label="lead"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <MdLeaderboard size={20} /> <span className="text">Leads</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/hotel/staff"
              data-label="Staff"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaUserTie size={20} /> <span className="text">Staff</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/hotel/expense"
              data-label="expense"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <SiExpensify size={20} /> <span className="text">Expense</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/hotel/payments"
              data-label="Payments"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaMoneyBillWave size={20} />
              <span className="text">Payments</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/hotel/enquiry"
              data-label="Enquiry"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaChartBar size={20} /> <span className="text">Enquiry</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/hotel/settings"
              data-label="Settings"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaCog size={20} />
              <span className="text">Settings</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
}
